import ApiUrl from '../services/APIUrl';
import { handleError, handleSuccess } from '../services/DataHelperFunctions';
import { appSettings } from '../settings';
import AxiosClient from './AxiosClient';
import { errorHandle, successHandle } from '../services/ErrorHandle';
import { EUrlParams } from '../data/Constants';

import type { IMasterView, IProductType } from '../../types';
import type { IActionPayload, IApiError } from '../../types/IApiTypes';
import { IPagination } from '../../types/IRequestTypes';

export const CategoryApi = {
  //This method returns the List Of Values
  getMaster: (payload: IActionPayload) => {
    const params: Record<string, string | null> = {};

    if (payload?.productCode) {
      params[EUrlParams.Search] = `${payload.productCode}`;
    }

    return AxiosClient.get(ApiUrl.ReadMaster, {
      params,
      baseURL: appSettings.DisEndpoint,
    })
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((error: IApiError) => {
        errorHandle(error);
        return error.response;
      });
  },

  getFeatureFamilies: (payload: IProductType) => {
    return AxiosClient.post(ApiUrl.ReadFamilyFeature, {
      workItemId: payload.workItemNum,
      code: '',
      includeScopeFeatures: payload.includeScopeFeatures,
      productCode: payload.productCode,
    })
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((error: IApiError) => {
        errorHandle(error);
        return error.response;
      });
  },

  getCategories: (action: IPagination) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(action.page),
      [EUrlParams.Limit]: String(action.limit),
    });
    return AxiosClient.post(
      `${ApiUrl.ReadCategories}?${queryParams}`,
      {},
      {
        baseURL: appSettings.DisEndpoint,
      }
    )
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((error: IApiError) => {
        errorHandle(error);
        return error.response;
      });
  },

  saveMaster: (payload: IMasterView) => {
    return AxiosClient.post(ApiUrl.SaveMaster, payload, {
      baseURL: appSettings.DisEndpoint,
    })
      .then((response) => {
        successHandle(response);
        return payload;
      })
      .catch((error: IApiError) => {
        return errorHandle(error);
      });
  },

  getMultiNumericFeatures: (payload: { searchKey: string | null }, skipLoader: boolean = false) => {
    const isActive = true;
    return AxiosClient.post(
      ApiUrl.ReadMultiNumericFeature,
      {
        active: isActive,
      },
      {
        params: { [EUrlParams.Search]: `${payload.searchKey}` },
        headers: { skipLoader: skipLoader },
      }
    )
      .then((response) => {
        return response;
      })
      .catch((error: IApiError) => {
        return handleError(error);
      });
  },
};
